import { render, staticRenderFns } from "./AccordionObjective.vue?vue&type=template&id=16178838&scoped=true"
import script from "./AccordionObjective.vue?vue&type=script&lang=js"
export * from "./AccordionObjective.vue?vue&type=script&lang=js"
import style0 from "./AccordionObjective.vue?vue&type=style&index=0&id=16178838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16178838",
  null
  
)

export default component.exports